export default __webpack_public_path__ + "static/media/producktive_demo_image.11216bef.png";